import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { insideItems } from '../data/gallery';
export function VisualSection() {
  return <section className="py-20 px-4 bg-cream" data-id="element-306" data-mp="2urlqfht25jf">
      <div className="max-w-5xl mx-auto" data-id="element-307" data-mp="2tzoz1ch21rk">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="grid md:grid-cols-[1fr_1.4fr] gap-8 md:gap-12 items-start" data-id="element-308" data-mp="2x5daeda0zm8">
          <div data-id="element-309" data-mp="3u2x1373l005v">
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-5 text-forest uppercase" data-id="element-310" data-mp="3g9xpvhau0s44">
              See What Your Plants Are Telling You
            </h2>
            <p className="text-xl font-semibold text-forest mb-1" data-id="element-311" data-mp="3l6o19rboyzj7">Hydroponics is visual.</p>
            <p className="text-xl font-semibold text-leaf mb-5" data-id="element-312" data-mp="36dkxqnuxqmbh">
              Your growing system should be visual too.
            </p>
            <p className="text-charcoal leading-relaxed" data-id="element-313" data-mp="erbykpcn5bwx">
              <span className="font-semibold text-forest" data-id="element-314" data-mp="epr3mymezqyj">Hydroponics Grower Ready</span> is built
              around diagrams, system maps, plant examples, root comparisons, growing sequences,
              crop profiles and quick-reference tools.
            </p>
          </div>

          <div className="bg-sage-50 border border-sage-200 rounded-2xl p-6" data-id="element-315" data-mp="jr6mck14dldr">
            <p className="text-sm font-bold text-forest uppercase tracking-wider mb-4" data-id="element-316" data-mp="3s7jlkhsxdp9w">
              Inside you’ll find:
            </p>
            <ul className="grid sm:grid-cols-2 gap-x-4 gap-y-2.5" data-id="element-317" data-mp="3n5aphckra73k">
              {insideItems.map(item => <li key={item} className="flex items-start gap-2 text-sm text-charcoal" data-id="element-318" data-mp="4v8w1idvnb9g">
                  <CheckCircle2 size={16} className="text-leaf shrink-0 mt-0.5" data-id="element-319" data-mp="l57cvei4rp" />
                  <span data-id="element-320" data-mp="38gy04yg6bmi1">{item}</span>
                </li>)}
            </ul>
          </div>
        </motion.div>

        <p className="text-center text-2xl md:text-4xl font-extrabold tracking-tight text-forest mt-14" data-id="element-321" data-mp="34f31y2tjhp8h">
          <span className="text-leaf" data-id="element-322" data-mp="1cfctnmpo05g4">100% VISUAL.</span> PRACTICAL. BUILT TO USE.
        </p>
      </div>
    </section>;
}